export default {
  title: {
    en: 'Change frequency',
  },
}
